/* eslint-disable @typescript-eslint/camelcase */
import { DateTime } from 'luxon';
import userState from '@/store/user';
import { FieldChildrenProp } from '@/services/hexabase/types';
import {
  MasterSelectDataColumns
} from '@/constants/matter/matter';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  export const MatterRegisterOptions = [
    {
      display_id: 'customer_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_customer',
      props: {
        label: '',
        labelName: ['見込顧客番号', '顧客名'],
        name: 'customer_id',
        value: '',
        dialogTitle: '顧客検索',
        outPutData: [
          {
            label: '顧客',
            name: 'customer_name',
            value: '',
            isDisabled: true
          },
          {
            label: '顧客担当者',
            name: 'manager',
            value: '',
            isDisabled: true
          },
          {
            label: '顧客連絡先',
            name: 'telephone_number',
            value: '',
            isDisabled: true
          }
        ],
      }
    },
    {
      display_id: 'order_manager_code',
      component: 'MasterSelectSetControl',
      dblookup: 'm_employee',
      props: {
        label: '',
        name: 'order_manager_code',
        value: '',
        columns: MasterSelectDataColumns.orderManagerCode,
        dialogTitle: '案件担当者選択',
        outPutData: [
          { label: '担当者コード', name: 'order_manager_code', isDisabled: true },
          { label: '案件担当者', name: 'name', isDisabled: true }
        ],
      }
    },
    {
      display_id: 'expected_sales_month',
      props: {
        format: 'yyyy/MM',
        type: 'month'
      }
    },
    {
      display_id: 'department_billing_address_id',
      component: 'MasterSelectMultiSetControl',
      props: {
        label: '',
        labelName: ['部署番号', '部署名'],
        name: 'department_billing_address_id',
        value: '',
        columns: MasterSelectDataColumns.CustomerDepartmentFrom,
        dialogTitle: '顧客部署検索',
        searchLargeItemData: {
          findItemName:'department_id',
          setItemValue:'department_id',
          setItemText:'department_id'
        },
        searchSmallItemData: {
          findItemName:'department_name',
          setItemValue:'department_name',
          setItemText:'department_name'
        },
        outPutData: [
          {
            label: '顧客部署(申込元・請求先)',
            name: 'department_name',
            value: '',
            isDisabled: true
          }
        ],
      }
    },
    {
      display_id: 'department_delivery_destination_id',
      component: 'MasterSelectMultiSetControl',
      props: {
        label: '',
        labelName: ['部署番号', '部署名'],
        name: 'department_delivery_destination_id',
        value: '',
        columns: MasterSelectDataColumns.CustomerDepartmentTo,
        dialogTitle: '顧客部署検索',
        searchLargeItemData: {
          findItemName:'department_id',
          setItemValue:'department_id',
          setItemText:'department_id'
        },
        searchSmallItemData: {
          findItemName:'department_name',
          setItemValue:'department_name',
          setItemText:'department_name'
        },
        outPutData: [
          {
            label: '顧客部署(設置先・納入先)',
            name: 'department_name',
            value: '',
            isDisabled: true
          }
        ],
      }
    },
    {
      display_id: 'service_type_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_service_type',
      props: {
        label: '',
        name: 'service_type_id',
        value: '',
        columns: MasterSelectDataColumns.ServiceType,
        dialogTitle: 'サービス種別検索',
        outPutData: [
          { label: 'サービス種別', name: 'service_type', isDisabled: true }
        ],
      }
    },
    {
      display_id: 'payment_information',
      component: 'SelectArea',
      props: {
        name: 'payment_information',
        label: '支払情報'
      }
    },
    {
      display_id: 'installation_address',
      props: {
        tooltipProps: {
          disapled: false,
          bottom: true,
        }
      }
    }    
  ];
  export const MatterEditOptions = [
    {
      display_id: 'customer_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_customer',
      props: {
        label: '',
        labelName: ['見込顧客番号', '顧客名'],
        name: 'customer_id',
        dialogTitle: '顧客検索',
        outPutData: [
          {
            label: '顧客',
            name: 'customer_name',
            value: '',
            isDisabled: true
          },
          {
            label: '顧客担当者',
            name: 'manager',
            value: '',
            isDisabled: true
          },
          {
            label: '顧客連絡先',
            name: 'telephone_number',
            value: '',
            isDisabled: true
          }
        ],
      }
    },
    {
      display_id: 'expected_sales_month',
      props: {
        format: 'yyyy/MM',
        type: 'month'
      }
    },
    {
      display_id: 'order_manager_code',
      component: 'MasterSelectSetControl',
      dblookup: 'm_employee',
      props: {
        label: '',
        name: 'order_manager_code',
        columns: MasterSelectDataColumns.orderManagerCode,
        dialogTitle: '案件担当者選択',
        outPutData: [
          { label: '担当者コード', name: 'order_manager_code', isDisabled: true },
          { label: '案件担当者', name: 'name', isDisabled: true }
        ],
      }
    },
    {
      display_id: 'department_billing_address_id',
      component: 'MasterSelectMultiSetControl',
      props: {
        label: '',
        labelName: ['部署番号', '部署名'],
        name: 'department_billing_address_id',
        columns: MasterSelectDataColumns.CustomerDepartmentFrom,
        dialogTitle: '顧客部署検索',
        searchLargeItemData: {
          findItemName:'department_id',
          setItemValue:'department_id',
          setItemText:'department_id'
        },
        searchSmallItemData: {
          findItemName:'department_name',
          setItemValue:'department_name',
          setItemText:'department_name'
        },
        outPutData: [
          {
            label: '顧客部署(申込元・請求先)',
            name: 'department_name',
            value: '',
            isDisabled: true
          }
        ],
      }
    },
    {
      display_id: 'department_delivery_destination_id',
      component: 'MasterSelectMultiSetControl',
      props: {
        label: '',
        labelName: ['部署番号', '部署名'],
        name: 'department_delivery_destination_id',
        columns: MasterSelectDataColumns.CustomerDepartmentTo,
        dialogTitle: '顧客部署検索',
        searchLargeItemData: {
          findItemName:'department_id',
          setItemValue:'department_id',
          setItemText:'department_id'
        },
        searchSmallItemData: {
          findItemName:'department_name',
          setItemValue:'department_name',
          setItemText:'department_name'
        },
        outPutData: [
          {
            label: '顧客部署(設置先・納入先)',
            name: 'department_name',
            value: '',
            isDisabled: true
          }
        ],
      }
    },
    {
      display_id: 'service_type_id',
      component: 'MasterSelectSetControl',
      dblookup: 'm_service_type',
      props: {
        label: '',
        name: 'service_type_id',
        columns: MasterSelectDataColumns.ServiceType,
        dialogTitle: 'サービス種別検索',
        outPutData: [
          { label: 'サービス種別', name: 'service_type', isDisabled: true }
        ],
      }
    },
    {
      display_id: 'payment_information',
      component: 'SelectArea',
      props: {
        name: 'payment_information',
        label: '支払情報'
      }
    },
    {
      display_id: 'project_name',
      props: {
        tooltipProps: {
          disapled: false,
          bottom: true,
        }
      }
    },
    {
      display_id: 'installation_address',
      props: {
        tooltipProps: {
          disapled: false,
          bottom: true,
        }
      }
    }
  ];
  export const MatterOAChangeOptions = [
    {
      display_id: 'schedule_project_completion_date',
      props: {
        name: 'schedule_project_completion_date',
        labelText: '工事完了予定日',
        format: 'yyyy/MM/dd'
      }
    },
    {
      display_id: 'project_completion_date',
      props: {
        name: 'project_completion_date',
        labelText: '工事完了日',
        format: 'yyyy/MM/dd'
      }
    }
  ];
  export const MatterGeneralChangeOptions = [
    {
      display_id: 'schedule_project_completion_date',
      props: {
        name: 'schedule_project_completion_date',
        labelText: '案件完了予定日',
        format: 'yyyy/MM/dd'
      }
    },
    {
      display_id: 'project_completion_date',
      props: {
        name: 'project_completion_date',
        labelText: '案件完了日',
        format: 'yyyy/MM/dd'
      }
    }
  ];
  export const MatterFJapanChangeOptions = [
    {
      display_id: 'schedule_project_completion_date',
      props: {
        name: 'schedule_project_completion_date',
        labelText: '案件完了予定日',
        format: 'yyyy/MM/dd'
      }
    },
    {
      display_id: 'project_completion_date',
      props: {
        name: 'project_completion_date',
        labelText: '案件完了日',
        format: 'yyyy/MM/dd'
      }
    }
  ];
}

export const matterRegisterOptionalForm = optionalForm.MatterRegisterOptions;
export const matterEditOptionalForm = optionalForm.MatterEditOptions;
export const matterOptionalChangeForm:any = {
  '1': optionalForm.MatterOAChangeOptions,
  '99': optionalForm.MatterGeneralChangeOptions,
  '2': optionalForm.MatterFJapanChangeOptions
};
